module.exports = __webpack_public_path__ + "img/full5-min.903f135a.png";